import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import { Layout } from "antd";

import Step1Form from "./Step_1_Form";

import "../steps.css";
import "./Step_1.css";

@inject("profileStore", "translationsStore", "registrationStore")
@observer
export default class Step_1 extends Component {
  constructor(props) {
    super(props);
    this.props.registrationStore.setPosition(2);
  }

  render() {
    return (
      <Layout style={{ justifyContent: "space-between", minHeight: "100%" }} className="Step_1 Steps">
        <Layout style={{ alignItems: "center", justifyContent: "center" }}>
          <Step1Form />
        </Layout>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_1/Step_1.js